module.exports = __webpack_public_path__ + "static/media/mobile13.a042c28b.png";